import client from "../../client/client";

class CommitmentDefinitionService {
	// Commitment Definition CRUD
	createCommitmentDefinition(payload, cancelToken) {
		return client.post("/backoffice/commitment-definition", {
			payload,
			config: { cancelToken },
		});
	}

	getCommitmentDefinition({ id }, cancelToken) {
		return client.get(`/backoffice/commitment-definition/${id}`, {
			config: { cancelToken },
		});
	}

	updateCommitmentDefinition({ id }, payload, cancelToken) {
		return client.put(`/backoffice/commitment-definition/${id}`, {
			payload,
			config: { cancelToken },
		});
	}

	deleteCommitmentDefinition({ id }, cancelToken) {
		return client.delete(`/backoffice/commitment-definition/${id}`, {
			config: { cancelToken },
		});
	}

	getAllCommitmentDefinitions({ name, page = 0, size = 20, themeIds }, cancelToken) {
		const params = { page, size };
		const payload = {};

		if (name) {
			payload.name = name;
		}
		if (themeIds && themeIds.length > 0) {
			payload.themeIds = themeIds;
		}

		return client.post("/backoffice/commitment-definition/all", {
			params,
			payload,
			config: { cancelToken },
		});
	}

	// Theme CRUD
	createTheme(payload, cancelToken) {
		return client.post("/backoffice/commitment-definition/theme", {
			payload,
			config: { cancelToken },
		});
	}

	updateTheme({ id }, payload, cancelToken) {
		return client.put(`/backoffice/commitment-definition/theme/${id}`, {
			payload,
			config: { cancelToken },
		});
	}

	deleteTheme({ id }, cancelToken) {
		return client.delete(`/backoffice/commitment-definition/theme/${id}`, {
			config: { cancelToken },
		});
	}

	getAllThemes(cancelToken) {
		return client.get("/backoffice/commitment-definition/theme/all", {
			config: { cancelToken },
		});
	}

	updateThemeOrder(payload, cancelToken) {
		return client.put("/backoffice/commitment-definition/theme/order", {
			payload,
			config: { cancelToken },
		});
	}
}

export default new CommitmentDefinitionService();
